import { Control } from "react-hook-form";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { endpointPrincipal } from "../../../../../../../api/endPoints/endpointPrincipal/endpointPrincipal";
import CustomSelect, { OpcaoSelect } from "../../../../../../../components/Formularios/Inputs/CustomSelect";

interface SelectEmpresasProps {
  name: string;
  control: Control<any>;
  label: string;
  disabled?: boolean;
}

interface Empresa {
  id_empresa: number;
  fantasia: string;
  razao_social: string;
}

export const SelectEmpresas = ({ name, control, label, disabled }: SelectEmpresasProps) => {
  const [empresas, setEmpresas] = useState<OpcaoSelect[]>([]);

  const carregarEmpresas = async () => {
    try {
      const { data } = await endpointPrincipal.get("/empresas");
      setEmpresas(
        (data as Empresa[]).map((empresa) => ({
          valor: empresa.id_empresa,
          label: empresa.fantasia || empresa.razao_social,
        }))
      );
    } catch (error) {
      toast.error("Erro ao carregar empresas: " + error);
    }
  };

  useEffect(() => {
    carregarEmpresas();
  }, []);

  return (
    <CustomSelect
      name={name}
      control={control}
      label={label}
      opcoes={empresas}
      disabled={disabled}
      required
    />
  );
};
